class MarqueeBanner extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector('.marquee-banner__content');
    this.speed = this.content.dataset.marqueeSpeed || 30;
    this.init();
  }

  init() {
    if (!this.content) return;
    
    // Set CSS custom properties for dynamic values
    this.style.setProperty('--marquee-duration', `${this.speed}s`);
    
    // Set padding if specified in section settings
    const section = this.closest('.marquee-banner-section');
    if (section) {
      const paddingTop = section.dataset.paddingTop;
      const paddingBottom = section.dataset.paddingBottom;
      
      if (paddingTop) {
        this.style.setProperty('--marquee-padding-top', `${paddingTop}rem`);
      }
      if (paddingBottom) {
        this.style.setProperty('--marquee-padding-bottom', `${paddingBottom}rem`);
      }
    }
    
    // Ensure content width is properly calculated for smooth scrolling
    this.updateContentWidth();
    
    // Pause animation on hover for better readability
    this.addEventListener('mouseenter', () => {
      if (this.content) {
        this.content.style.animationPlayState = 'paused';
      }
    });
    
    this.addEventListener('mouseleave', () => {
      if (this.content) {
        this.content.style.animationPlayState = 'running';
      }
    });
    
    // Handle reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.disableAnimation();
    }
    
    // Listen for changes in reduced motion preference
    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', (e) => {
      if (e.matches) {
        this.disableAnimation();
      } else {
        this.enableAnimation();
      }
    });
    
    // Handle window resize to recalculate content width
    window.addEventListener('resize', () => {
      this.updateContentWidth();
    });
  }
  
  updateContentWidth() {
    if (this.content) {
      // Force a reflow to ensure accurate width calculation
      this.content.style.width = 'max-content';
      this.content.offsetHeight; // Trigger reflow
      
      // Ensure the content spans the full width needed for smooth scrolling
      const items = this.content.querySelectorAll('.marquee-banner__item');
      let totalWidth = 0;
      
      items.forEach(item => {
        totalWidth += item.offsetWidth;
      });
      
      // Set minimum width to ensure smooth scrolling
      if (totalWidth > 0) {
        this.content.style.minWidth = `${totalWidth * 2}px`;
      }
    }
  }
  
  disableAnimation() {
    if (this.content) {
      this.content.style.animation = 'none';
      this.content.style.transform = 'translateX(0)';
    }
  }
  
  enableAnimation() {
    if (this.content) {
      this.content.style.animation = `marquee-scroll ${this.speed}s linear infinite`;
      this.content.style.transform = '';
    }
  }
}

customElements.define('marquee-banner', MarqueeBanner);

// Initialize existing marquee banners
document.addEventListener('DOMContentLoaded', () => {
  const marqueeBanners = document.querySelectorAll('.marquee-banner');
  marqueeBanners.forEach(banner => {
    if (!banner.marqueeBanner) {
      banner.marqueeBanner = new MarqueeBanner();
    }
  });
});

// Handle Shopify section updates
document.addEventListener('shopify:section:load', (event) => {
  const marqueeBanner = event.target.querySelector('.marquee-banner');
  if (marqueeBanner) {
    marqueeBanner.marqueeBanner = new MarqueeBanner();
  }
});
